import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner
} from "../../../core/reel/winpresentation/SimplePresentationRunner";
import {DFFSIntroRunner} from "../../presentation/freespin/DFFSIntroRunner";
import {DFFSOutroRunner} from "../../presentation/freespin/DFFSOutroRunner";
import {DFWinExplodeRunner} from "../../presentation/baseGame/DFWinExplodeRunner";
import {DFWinHighlightRunner} from "../../presentation/baseGame/DFWinHighlightRunner";
import {DFTotalWinRunner} from "../../presentation/DFTotalWinRunner";
import {InfectiousXWaysRunner} from "../../presentation/InfectiousXWaysRunner";
import {XWaysRunner} from "../../presentation/XWaysRunner";
import {DFScatterRunner} from "../../presentation/freespin/DFScatterRunner";
import {DFWinCapRunner} from "../../presentation/DFWinCapRunner";
import {DFBigWinRunner} from "../../presentation/baseGame/DFBigWinRunner";
import {DFScatterTriggerRunner} from "../../presentation/baseGame/DFScatterRunner";
import {DumpsterFire} from "../../DumpsterFire";
import {DFRoundEndPresentation} from "../../presentation/baseGame/DFRoundEndPresentation";

export class DumpsterFireWinPresentation implements FlowStatePresentation {

    private _presentations: SimplePresentation[];
    private _flowStateController: FlowStateController;

    constructor() {
        this._presentations = [
            new XWaysRunner(),
            new InfectiousXWaysRunner(),
            new DFScatterRunner(),
            new DFWinHighlightRunner(),
            new DFWinExplodeRunner(),
            new DFRoundEndPresentation(),
            new DFBigWinRunner,
            new DFTotalWinRunner(),
            new DFScatterTriggerRunner(),
            new DFFSOutroRunner(),
            new DFWinCapRunner()
        ];
    }

    public start(flowStateController: FlowStateController) {
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    private complete(): void {
        DumpsterFire.model.calculatePrevMultiPos();
        this._flowStateController.finish();
    }
}